export const voiceTableConfig = {
  propList: [
    {prop: 'empName', label: '业务员', minWidth: '60', slotName: 'consumer'},
    {prop: 'callCount', label: '通话次数', minWidth: '60', sortable: true},
    {prop: 'callDuration', label: '通话总时长（分钟）', minWidth: '60', slotName: 'callDuration', sortable: true},
    {prop: 'averageCount', label: '平均通话时长（分钟）', minWidth: '60', slotName: 'averageCount', sortable: true}
  ]
}
